import React, { useState } from "react";
import classNames from "classnames";
import { TabName } from "./tabName";
import type { TabsProps } from "./dto";
import styles from "./index.module.less";

/**
 * 业务标签栏组件
 * @deprecated 1.x版本组件，不再维护，请尽快迁移至本地项目
 */
export default function Tabs(props: TabsProps) {
  /** 当前active index */
  const [curIndex, setCurIndex] = useState(props.defaultIndex || 0);

  function handleTab(e, index: number) {
    e.stopPropagation();
    if (index !== curIndex) {
      setCurIndex(index);
      props.handleTab(props.tabs[index]);
    }
  }

  return (
    <div className={classNames(styles.tabContainer, props.className)}>
      <div className={classNames(styles.tabs)}>
        {props.tabs.map((tab, index) => (
          <TabName
            key={index}
            active={curIndex === index}
            onClick={(e) => handleTab(e, index)}
          >
            {props.getName(tab)}
          </TabName>
        ))}
      </div>
    </div>
  );
}
